// Components/ProtectedRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token =
    typeof window !== "undefined" ? localStorage.getItem("token") : null;

  if (!token) {
    // ❌ Not logged in → redirect to login
    return <Navigate to="/" replace />;
  }

  // ✅ Token exists → allow access
  return children;
};

export default ProtectedRoute;